import React, { useEffect, useState } from "react";
import restaurantsData from "./restaurants.json";
import "./Dashboard.css";

export default function DashboardEditPage() {
  const [restaurants, setRestaurants] = useState([]);
  const [message, setMessage] = useState("");
  const [sortField, setSortField] = useState("placement");

  useEffect(() => {
    const sortedData = [...restaurantsData].sort((a, b) => (a[sortField] || 0) - (b[sortField] || 0));
    setRestaurants(sortedData);
  }, [sortField]);

  const showMessage = (text) => {
    setMessage(text);
    setTimeout(() => setMessage(""), 3000);
  };

  const handleChange = (e, index, field) => {
    const updated = [...restaurants];
    updated[index][field] = e.target.value;
    setRestaurants(updated);
  };

  const handleDelete = async (index) => {
    const deletedRestaurant = restaurants[index];
    try {
      const response = await fetch("http://localhost:5000/api/delete-restaurant", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ nickname: deletedRestaurant.nickname })
      });

      if (!response.ok) {
        throw new Error("Failed to delete restaurant");
      }

      const updated = [...restaurants];
      updated.splice(index, 1);
      setRestaurants(updated);
      showMessage(`Deleted: ${deletedRestaurant.nickname}`);
    } catch (error) {
      console.error("Delete error:", error);
      showMessage("Failed to delete restaurant.");
    }
  };

  const handleUpdate = async (index) => {
    const updatedRestaurant = restaurants[index];
    console.log(updatedRestaurant)
    try {
      const response = await fetch("http://localhost:5000/api/update-restaurant", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(updatedRestaurant)
      });

      if (!response.ok) {
        throw new Error("Failed to update restaurant");
      }

      showMessage(`Updated: ${updatedRestaurant.nickname}`);
    } catch (error) {
      console.error("Update error:", error);
      showMessage("Failed to update restaurant.");
    }
  };

  const handleUpdateAll = async () => {
    try {
      const response = await fetch("http://localhost:5000/api/update-all-restaurants", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(restaurants)
      });

      if (!response.ok) {
        throw new Error("Failed to update all restaurants");
      }

      showMessage("All restaurants updated successfully.");
    } catch (error) {
      console.error("Update all error:", error);
      showMessage("Failed to update all restaurants.");
    }
  };

  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Restaurant Data Dashboard</h1>
      {message && <div className="toast-message">{message}</div>}

      <div className="sort-dropdown">
        <label htmlFor="sortField">Sort by:&nbsp;</label>
        <select id="sortField" value={sortField} onChange={(e) => setSortField(e.target.value)}>
          <option value="placement">Placement</option>
          <option value="restaurant_name">Name</option>
          <option value="price">Price</option>
          <option value="michelinstars">Michelin Stars</option>
          <option value="tier">Tier</option>
        </select>
      </div>

      <div className="dashboard-table">
        <table>
          <thead>
            <tr>
              <th>Nickname</th>
              <th>Name</th>
              <th>Country</th>
              <th>City</th>
              <th>Month</th>
              <th>Year</th>
              <th>Tier</th>
              <th>Price</th>
              <th>Placement</th>
              <th>Stars</th>
              <th>Cuisine</th>
              <th>Website</th>
              <th>Michelin</th>
              <th>Map</th>
              <th>Review</th>
              <th>Photos</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {restaurants.map((restaurant, index) => (
              <tr key={index}>
                {Object.entries(restaurant).map(([key, value]) => (
                  <td key={key}>
                    <input
                      type="text"
                      value={value}
                      onChange={(e) => handleChange(e, index, key)}
                    />
                  </td>
                ))}
                <td>
                  <button className="update-button" onClick={() => handleUpdate(index)}>
                    Update
                  </button>
                  <button className="delete-button" onClick={() => handleDelete(index)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="update-all-wrapper">
          <button className="update-button" onClick={handleUpdateAll}>
            Update All
          </button>
        </div>
      </div>
    </div>
  );
}
